import './business.scss';
import businesscutted from '../../../assets/business-cutted.png';
const BusinessImageSvg: React.FC = () => {
  return (
    <svg
      width="189.1234mm"
      height="189.1234mm"
      viewBox="0 0 189.1234 189.1234"
      version="1.1"
      id="profileimage"
      
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="businessimageTitle businessimageDesc"
    >
      <title id="businessimageTitle">Business profile image</title>
      <desc id="businessimageDesc">Circular framed business portrait</desc>
      <defs id="defs1">
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath6">
          <circle id="businessframe" cx="191.35954" cy="188.37903" r="91.588219" />
        </clipPath>
      </defs>
      <g id="layer1" transform="translate(-93.954106,-94.958071)">
        <g id="g6">
          <image
            width="155.98151"
            height="207.97533"
            preserveAspectRatio="xMidYMid meet"
            href={businesscutted}
            id="image1-4"
            x="108"
            y="85"
            clipPath="url(#clipPath6)"
          />
          <circle id="businessframepath" cx="188.51579" cy="189.51976" r="91.588219" />
        </g>
      </g>
    </svg>
  );
};

export default BusinessImageSvg;
